import fnOpenToast from "../components/toast";
import { toast } from "react-toastify";

export const notifySuccess = () => {
    fnOpenToast("Fee Saved Successfully!!!", "success");
};

export const notifyError = (msg) => {
    if (msg) {
        toast.error(msg, { autoClose: 3000 });
    } else {
        toast.error("Oops Something Went Wrong!", { autoClose: 3000 });
    }
};
